module.exports = __webpack_public_path__ + "img/xl_phz.3ca4114b.png";